import { Instance } from 'mobx-state-tree';
import { RouteDispatchedDtoModelBase } from './RouteDispatchedDtoModel.base';

/* The TypeScript type of an instance of RouteDispatchedDtoModel */
export interface RouteDispatchedDtoModelType extends Instance<typeof RouteDispatchedDtoModel.Type> {}

/* A graphql query fragment builders for RouteDispatchedDtoModel */
export { selectFromRouteDispatchedDto, routeDispatchedDtoModelPrimitives, RouteDispatchedDtoModelSelector } from './RouteDispatchedDtoModel.base';

/**
 * RouteDispatchedDtoModel
 *
 * Route dispatched event
 */
export const RouteDispatchedDtoModel = RouteDispatchedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
